module.exports = __webpack_public_path__ + "media/images/icon_popup_industry-f810d388a34f1a9169e6c124379bb48b.png";